/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  InputHTMLAttributes,
  ReactChild,
  useMemo,
  useState,
} from 'react'
import CaretDownIcon from '../icons/CaretDown'
import { Select as StyledSelect, Content } from './styles'
import { DolaThemes } from '../../styles/types'
import { FauxInput, Label } from '../Input/styles'
import { P } from '../../styles/Elements'

type SelectOptions = {
  label: ReactChild
  value: string
}[]
export interface SelectProps
  extends Omit<InputHTMLAttributes<HTMLSelectElement>, 'placeholder'> {
  options: SelectOptions
  label: string
  placeholder?: string
  theme?: DolaThemes
}

const Select: React.FC<SelectProps> = ({
  options: suppliedOptions,
  label,
  onBlur,
  placeholder,
  theme = 'light',
  ...props
}) => {
  const [active, setActive] = useState(false)
  const fieldHasValue = !!props.value

  const displayLabel = fieldHasValue ? label : placeholder || label

  const options = useMemo(() => {
    const opt = [...suppliedOptions]

    // Add extra "placeholder" item if there's a place holder or no initial value is supplied
    if (placeholder || !fieldHasValue) {
      opt.unshift({
        label: placeholder || label,
        value: '',
      })
    }

    return opt
  }, [])

  const displayedOption =
    options.find(({ value: optionValue }) => optionValue === props.value)
      ?.label || ''

  return (
    <FauxInput dolaTheme={theme} mode={active ? 'active' : 'default'}>
      <Label
        dolaTheme={theme}
        mode={fieldHasValue ? 'active' : 'default'}
        toBorder={fieldHasValue}
      >
        {displayLabel}
      </Label>
      <StyledSelect
        onBlur={async (e: React.FocusEvent<any>) => {
          setActive(false)

          if (onBlur) {
            onBlur(e)
          }
        }}
        onFocus={() => {
          setActive(true)
        }}
        {...props}
      >
        {options.map((opt, index: number) => (
          <option value={opt.value} key={index}>
            {opt.label}
          </option>
        ))}
      </StyledSelect>
      <Content>
        <P className="nowrap">{fieldHasValue ? displayedOption : ''}</P>
        <CaretDownIcon />
      </Content>
    </FauxInput>
  )
}

export default Select
